module.exports = __webpack_public_path__ + "img/DSC01184.b828221b.jpg";